module.exports = __webpack_public_path__ + "img/H3.6b48439b.png";